import React, { useRef, useLayoutEffect, useState } from "react";
import { App } from "./src/App"

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './src/redux/store';


export function HotlineDemo(props){
  return (
    <Provider store={store}>
            <App/>
    </Provider>
  )
}

